import React from 'react';
import './styles.css';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, ThemeProvider, createTheme, Typography,Button, Tooltip  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import CustomTextField from '../CustomTextField';
import DateSelector from '../DateSelector';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import PeriodTable from '../PeriodTable';
import ClubCareerTable from '../ClubCareerTable';
import InternationalClubTable from '../InternationalClubTable';
import { useDispatch, useSelector } from 'react-redux';
import { setPlayerDetails, setSelectedPlayer } from '../../redux/reducers/dataCaptures';
import { formatDate } from '../../common/StaticExports';
import { deletePlayer } from '../../api/dataCapture';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          // display: 'inline',
          // width: '90px',
          paddingTop: '0px !important'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const PlayersTable = (props?: any) => {
    const { addData, handleClick } = props;

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');

  const data = useSelector((state:any) => state.dataCaptures.playerDetails);
  const clubDetails = useSelector((state:any) => state.clubDetails);
  const dispatch = useDispatch();
  const isAdmin = useSelector((state:any) => state.common.isAdmin);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () =>
      data?.length > 0 &&
      stableSort(data, getComparator(order, orderBy)),
    [order, orderBy, data],
  );

  const head = [
    {
        key: '', displayName: 'name',
    },
    {
        key: '', displayName: 'date of birth',
    },
    {
        key: '', displayName: 'current club',
    },
    {
        key: '', displayName: 'international',
    },
    {
        key: '', displayName: '',
    },
  ]
 
   const manageDeleteRow = (row:any) => {
     deletePlayer({ clubId: clubDetails?.id, id: row?.id })
     .then(() => {
       const tempData = data?.filter((item:any) => item?.id != row?.id);
       dispatch(setPlayerDetails(tempData));
     });
   }

  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative' }}>
              {/* table content is here */}
              <TableContainer sx={{ maxHeight: '34vh', overflowY: 'auto' }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    bg={'#FAFAFA'}
                    />
                    <TableBody>
                    {
                        visibleRows && visibleRows?.length &&
                        visibleRows?.map((d: any, i: number) => (
                        <TableRow
                        className='hoverBG'
                        sx={{ cursor: 'pointer' }}
                        key={`accountingpl-table-row-${i}`}
                        onClick={() => {dispatch(setSelectedPlayer(d))}}
                        >
                            <TableCell className='fs12'>
                                {d.name}
                            </TableCell>
                            <TableCell className='fs12'>
                                {formatDate(d.dateOfBirth)}
                            </TableCell>
                            <TableCell className='fs12'>
                                {
                                  d.clubCareers.length ?
                                  d.clubCareers[d.clubCareers.length - 1].club : '-'
                                }
                            </TableCell>
                            <TableCell className='fs12'>
                                {
                                  d.internationalCareers.length ?
                                  d.internationalCareers[d.internationalCareers.length - 1].country : '-'
                                }
                            </TableCell>
                            <TableCell>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={(e:any) => {e.stopPropagation(); !isAdmin && manageDeleteRow(d);}} className={isAdmin ? 'icon mr10 deleteIcon cursorNotAllowed' : 'icon mr10 deleteIcon'} icon={faTrash}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default PlayersTable;